globalThis.CheckTruncated = function (id) {
    const account = document.getElementById(id);
    if (!account) {
        console.warn(`Account with ID ${id} not found`);
        return false;
    }

    const accountText = account.querySelector("span");

    if (!accountText) {
        return false;
    }

    const isTruncated = accountText.scrollWidth > accountText.clientWidth;

    if (!isTruncated) {
        const anchor = account.closest(".ebizTooltip");

        if (anchor) {
            anchor.removeAttribute("title");
        }
    }

    return isTruncated;
};
